import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const a = "apple";
class n extends e {
  /**
   * Starts the Apple OAuth flow.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/apple/oauth`
   *
   * @returns {Promise<OauthFlowResponse>} A promise that resolves with the OAuth flow URL.
   */
  getOauthFlow = async () => {
    const { data: t } = await this.get(`${a}/oauth`);
    return t;
  };
  /**
   * Retrieves the list of Apple-connected companies.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/apple/companies`
   *
   * @returns {Promise<CompaniesResponse>} A promise that resolves with the list of companies.
   */
  getCompanies = async () => {
    const { data: t } = await this.get(`${a}/companies`);
    return t;
  };
}
export {
  n as AppleOAuth,
  a as RESOURCE_URI
};
